import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Pipe, NgModule } from '@angular/core';
import { toFixed, formatMoney } from 'accounting';

// Keeping this file around for NPP. Grants is now using an endpoint to grab formatting data.
const currencyFormattingData = {
    etb: {
        symbol: 'Fdj',
        precision: 0,
        thousand: ',',
        decimal: '.'
    },
    zar: {
        symbol: 'R',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    aed: {
        symbol: 'د.إ.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    bhd: {
        symbol: 'د.ب.',
        precision: 3,
        thousand: ',',
        decimal: '.'
    },
    dzd: {
        symbol: 'د.ج ',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    egp: {
        symbol: 'ج.م.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    iqd: {
        symbol: 'د.ع.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    jod: {
        symbol: 'د.ا.',
        precision: 3,
        thousand: ',',
        decimal: '.'
    },
    kwd: {
        symbol: 'د.ك.',
        precision: 3,
        thousand: ',',
        decimal: '.'
    },
    lbp: {
        symbol: 'ل.ل.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    lyd: {
        symbol: 'د.ل.',
        precision: 3,
        thousand: ',',
        decimal: '.'
    },
    mad: {
        symbol: 'د.م.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    omr: {
        symbol: 'ر.ع.',
        precision: 3,
        thousand: ',',
        decimal: '.'
    },
    qar: {
        symbol: 'ر.ق.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    sar: {
        symbol: 'ر.س.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    syp: {
        symbol: 'ل.س.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    tnd: {
        symbol: 'د.ت.',
        precision: 3,
        thousand: ',',
        decimal: '.'
    },
    yer: {
        symbol: 'ر.ي.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    clp: {
        symbol: '$',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    inr: {
        symbol: '₹',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    azn: {
        symbol: '₼',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    rub: {
        symbol: '₽',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    byn: {
        symbol: 'Br',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    bgn: {
        symbol: 'лв.',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    ngn: {
        symbol: '₦',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    bdt: {
        symbol: '৳',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    cny: {
        symbol: '¥',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    eur: {
        symbol: '€',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    bam: {
        symbol: 'КМ',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    usd: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    czk: {
        symbol: 'Kč',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    gbp: {
        symbol: '£',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    dkk: {
        symbol: 'kr.',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    chf: {
        symbol: 'CHF',
        precision: 2,
        thousand: '\'',
        decimal: '.'
    },
    mvr: {
        symbol: 'ރ.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    btn: {
        symbol: 'Nu.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    xcd: {
        symbol: 'EC$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    aud: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    bzd: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    cad: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    hkd: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    idr: {
        symbol: 'Rp',
        precision: 0,
        thousand: '.',
        decimal: ','
    },
    jmd: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    myr: {
        symbol: 'RM',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    nzd: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    php: {
        symbol: '₱',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    sgd: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    ttd: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    xdr: {
        symbol: 'XDR',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    ars: {
        symbol: '$',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    bob: {
        symbol: 'Bs',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    cop: {
        symbol: '$',
        precision: 0,
        thousand: '.',
        decimal: ','
    },
    crc: {
        symbol: '₡',
        precision: 0,
        thousand: ' ',
        decimal: ','
    },
    cup: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    dop: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    gtq: {
        symbol: 'Q',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    hnl: {
        symbol: 'L',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    mxn: {
        symbol: '$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    nio: {
        symbol: 'C$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    pab: {
        symbol: 'B/.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    pen: {
        symbol: 'S/',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    pyg: {
        symbol: '₲',
        precision: 0,
        thousand: '.',
        decimal: ','
    },
    uyu: {
        symbol: '$',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    ves: {
        symbol: 'Bs.S',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    irr: {
        symbol: 'ريال',
        precision: 2,
        thousand: ',',
        decimal: '/'
    },
    xof: {
        symbol: 'CFA',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    cdf: {
        symbol: 'FC',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    xaf: {
        symbol: 'FCFA',
        precision: 0,
        thousand: ' ',
        decimal: ','
    },
    htg: {
        symbol: 'G',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    ils: {
        symbol: '₪',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    hrk: {
        symbol: 'kn',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    huf: {
        symbol: 'Ft',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    amd: {
        symbol: '֏',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    isk: {
        symbol: 'ISK',
        precision: 0,
        thousand: '.',
        decimal: ','
    },
    jpy: {
        symbol: '¥',
        precision: 0,
        thousand: ',',
        decimal: '.'
    },
    gel: {
        symbol: '₾',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    kzt: {
        symbol: '₸',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    khr: {
        symbol: '៛',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    krw: {
        symbol: '₩',
        precision: 0,
        thousand: ',',
        decimal: '.'
    },
    kgs: {
        symbol: 'сом',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    lak: {
        symbol: '₭',
        precision: 0,
        thousand: '.',
        decimal: ','
    },
    mkd: {
        symbol: 'ден',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    mnt: {
        symbol: '₮',
        precision: 0,
        thousand: ',',
        decimal: '.'
    },
    bnd: {
        symbol: '$',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    mmk: {
        symbol: 'K',
        precision: 0,
        thousand: ',',
        decimal: '.'
    },
    nok: {
        symbol: 'kr',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    npr: {
        symbol: 'र',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    pkr: {
        symbol: 'Rs',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    pln: {
        symbol: 'zł',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    afn: {
        symbol: '؋',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    brl: {
        symbol: 'R$',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    mdl: {
        symbol: 'L',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    ron: {
        symbol: 'RON',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    rwf: {
        symbol: 'RF',
        precision: 0,
        thousand: '.',
        decimal: ','
    },
    sek: {
        symbol: 'kr',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    lkr: {
        symbol: 'රු.',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    sos: {
        symbol: 'S',
        precision: 0,
        thousand: ',',
        decimal: '.'
    },
    all: {
        symbol: 'Lekë',
        precision: 0,
        thousand: ' ',
        decimal: ','
    },
    rsd: {
        symbol: 'дин.',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    kes: {
        symbol: 'Ksh',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    tjs: {
        symbol: 'смн',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    thb: {
        symbol: '฿',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    ern: {
        symbol: 'Nfk',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    tmt: {
        symbol: 'm.',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    bwp: {
        symbol: 'P',
        precision: 2,
        thousand: ' ',
        decimal: '.'
    },
    try: {
        symbol: '₺',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    uah: {
        symbol: '₴',
        precision: 2,
        thousand: ' ',
        decimal: ','
    },
    uzs: {
        symbol: 'сўм',
        precision: 0,
        thousand: ' ',
        decimal: ','
    },
    vnd: {
        symbol: '₫',
        precision: 2,
        thousand: '.',
        decimal: ','
    },
    mop: {
        symbol: 'MOP',
        precision: 2,
        thousand: ',',
        decimal: '.'
    },
    twd: {
        symbol: 'NT$',
        precision: 2,
        thousand: ',',
        decimal: '.'
    }
};
function getCurrencyFormattingData(currencyCode) {
    return currencyFormattingData[currencyCode] || currencyFormattingData.usd;
}
var CurrencyRadioOptions;
(function (CurrencyRadioOptions) {
    CurrencyRadioOptions[CurrencyRadioOptions["USE_ONE_CURRENCY"] = 1] = "USE_ONE_CURRENCY";
    CurrencyRadioOptions[CurrencyRadioOptions["USE_ANY_CURRENCY"] = 2] = "USE_ANY_CURRENCY";
})(CurrencyRadioOptions || (CurrencyRadioOptions = {}));

class MoneyService {
    toFixedNumber(number, precision) {
        return +(toFixed(number, precision));
    }
    toFixedString(number, precision) {
        return toFixed(number, precision);
    }
    getFormattingData(numberOfDecimals, requireDecimal, currencyData, numberFormattingData) {
        let thousands;
        let decimal;
        let decimalLimit;
        if (currencyData) {
            thousands = currencyData.thousand;
            decimal = currencyData.decimal;
            decimalLimit = currencyData.precision ?? 2;
            requireDecimal = true;
        }
        else {
            thousands = numberFormattingData.group;
            decimal = numberFormattingData.decimal;
            decimalLimit = numberOfDecimals ?? 2;
        }
        return {
            thousands,
            allowDecimal: decimalLimit > 0,
            decimal,
            decimalLimit,
            requireDecimal
        };
    }
    formatMoney(amount, currency, formatting) {
        const lcCurrency = currency?.toLowerCase();
        if (!formatting) {
            return formatMoney(amount, getCurrencyFormattingData(lcCurrency));
        }
        return formatMoney(amount, formatting);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: MoneyService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: MoneyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: MoneyService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

// Note: This is just for NPP. Grants has it's own gcMoney pipe
class MoneyPipe {
    constructor(moneyService) {
        this.moneyService = moneyService;
    }
    transform(amount, currency, showCurrencyAtEnd = false) {
        const lcCurrency = currency?.toLowerCase();
        const formatted = this.moneyService.formatMoney(amount, lcCurrency);
        return showCurrencyAtEnd ?
            `${formatted}  ${currency?.toUpperCase()}` :
            formatted;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: MoneyPipe, deps: [{ token: MoneyService }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: MoneyPipe, isStandalone: false, name: "money" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: MoneyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'money',
                    standalone: false
                }]
        }], ctorParameters: () => [{ type: MoneyService }] });

class CurrencyModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CurrencyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "19.2.10", ngImport: i0, type: CurrencyModule, declarations: [MoneyPipe], imports: [CommonModule], exports: [MoneyPipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CurrencyModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.2.10", ngImport: i0, type: CurrencyModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [
                        MoneyPipe
                    ],
                    exports: [
                        MoneyPipe
                    ],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CurrencyModule, CurrencyRadioOptions, MoneyPipe, MoneyService, currencyFormattingData, getCurrencyFormattingData };
